import "./PrescriptionCard.scss";
import "../../pages/doctor-console/DoctorConsole.scss";
import { Select, Space } from "antd";
import { Link } from "react-router-dom";
import {
  Modal,
  Box,
  Typography,
  Button as muiButton,
  IconButton,
  Grid,
  Card,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import { Icon, TableHead } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"; // Import the close icon
import { useEffect, useState, useRef, useMemo } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import closeIcon from "../../assets/img/Path 49373.svg";
import viewIcon from "../../assets/img/eye-look.svg";
import downloadIcon from "../../assets/img/Download-icon.svg";
import prescriprionIcon from "../../assets/img/prescription.png";
import "../PatientReport/PatientReport.scss";
// import prescriptionArr from './prescription-sample.json';
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import { Row, Col } from "../../components/RowCol";
// import { Container, Image, Accordion } from 'react-bootstrap';
import { Table } from "react-bootstrap";
import { Line } from "react-chartjs-2";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { filter } from "d3";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"; // Import the MUI icon
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { useSpeechRecognition as kit } from "react-speech-kit";
import { CheckToken } from "../../pages/login/AccessToken";
import Navlogo from "../../assets/images/logo/NavLogo.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import JoditEditor from "jodit-react";
import bhashini from "bhashini-translation";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import MicOffIcon from "@mui/icons-material/MicOff";
import EditIcon from "@mui/icons-material/Edit";
import { toast } from "react-toastify";
import HiTypeHeader from "../../pages/doctor-console/Utils/HiTypeHeader";
import {
  formatDateIST,
  separateCamelCase,
} from "../../pages/doctor-console/Utils/UtilsFunctions";
import { DoctorconsoleGrid } from "../../pages/doctor-console/StyledComponents";
bhashini.auth(
  "eea8a85476ff48019f24136567e4b195",
  "228c7a3d15-0267-4c2e-87da-7c99eeb1c9d5",
  "07FSq456BC5ONmmIh9e7pgzkRn9rIaw8XJd2HJvy423qMTucRXEz_tH7xAZgofIs"
);
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
function PrescriptionCard(props) {
  const [value, setValue] = useState("");
  const { listen, stop } = kit({
    onResult: (result) => {
      setValue(result);
    },
  });
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const history = useHistory();
  const [message, setMessage] = useState("");
  const [prevMessage, setPrevMessage] = useState("");
  const [editing, setEditing] = useState(false);
  const commands = [
    {
      command: /(select) (.+)/i,
      callback: (_, select, specifiedPhrase) => {
        const regex = new RegExp(`(${select})([\\s\\S]*?)(?=\\n\\n|$)`, "gi");
        // Create a case-insensitive regex for the specified phrase
        // console.log("Selectttttttttttttttttttttttt", select);
        // console.log("Phraseeeeeeeeeeeeeeeeeeeeee", specifiedPhrase);
        let updatedTranscript = transcript.replace(regex, (matchedPhrase) => {
          return `<span style="background-color: yellow;">${matchedPhrase}</span>`;
        });
        const newUpdatedTranscript = updatedTranscript.replace(
          new RegExp("select " + select, "g"),
          "" // Use "\n" to represent a newline character
        );
        setMessage(prevMessage + newUpdatedTranscript);
      },
      matchInterim: true,
    },
    ,
    {
      command: /(Number|No|no|number) (\d+)/, // Match either "Number" or "No" followed by one or more digits
      callback: (number, keyword) => {
        // Convert the spoken number to a digit
        // console.log("Number n keyword", number, keyword);
        const digit = parseInt(number, 10);
        // Replace both "Number" or "No" with the digit in the transcript
        const updatedTranscript = transcript.replace(
          new RegExp(`(${keyword} ${number})`, "g"),
          digit.toString()
        );
        // console.log(digit, updatedTranscript);
        setMessage(updatedTranscript);
      },
      matchInterim: true,
    },
    {
      command: "go to the next line",
      callback: () => {
        const updatedTranscript = transcript.replace(
          new RegExp("go to the next line", "g"),
          "\n" // Use "\n" to represent a newline character
        );
        setMessage(prevMessage + updatedTranscript);
      },
      matchInterim: true, // This flag allows it to match interim results (works while speaking)
    },
    {
      command: "reset",
      callback: ({ resetTranscript }) => {
        resetTranscript(); // Clear the current transcript
      },
    },
  ];
  const [text, setText] = useState(null);
  const [languageCode, setLanguageCode] = useState("en");

  const languages = [
    {
      name: "English",
      code: "en",
    },
    {
      name: "Hindi",
      code: "hi",
    },
    {
      name: "Bengali",
      code: "bn",
    },
  ];

  const handleAudioCapture = async (event) => {
    const audioFile = event.target.files[0];

    // Convert the audio file to Base64
    const reader = new FileReader();

    reader.onloadend = async () => {
      const base64Audio = reader.result.split(",")[1]; // Extracting base64 content
      // console.log("base64 audio:", base64Audio);

      try {
        const recognizedText = await bhashini.asr(languageCode, base64Audio); // Pass the base64 audio to bhashini.asr
        // console.log("Recognized Text:", recognizedText);
        setText(recognizedText);
        // Do something with the recognized text
      } catch (error) {
        console.error("ASR Error:", error);
      }
    };

    reader.readAsDataURL(audioFile);
  };
  // console.log("Language codeeeeeeeeeeee", languageCode);

  const handleSaveClick = () => {
    const section1Content = document.getElementById("jodit-1").innerHTML;
    const section2Content = document.getElementById("jodit-2").innerHTML;
    const section3Content = document.getElementById("jodit-3").innerHTML;
    const section4Content = document.getElementById("jodit-4").innerHTML;
    const section5Content = document.getElementById("jodit-5").innerHTML;
    const section6Content = document.getElementById("jodit-6").innerHTML;
    const section7Content = document.getElementById("jodit-7").innerHTML;

    // console.log("Contents", section1Content, section2Content);
    const ans = {
      section1: section1Content,
      section2: section2Content,
      section3: section3Content,
      section4: section4Content,
      section5: section5Content,
      section6: section6Content,
      section7: section7Content,
    };

    // console.log("Before navigating to preview", ans, sectionsContent);
    history.push({
      pathname: "/doctor/PrescriptionPreview",
      state: {
        ans: ans,
        content: sectionsContent,
        summaryData: summaryData,
        // Other data to pass to the next route if needed
      },
    });
  };
  const { transcript, resetTranscript } = useSpeechRecognition();

  const [sectionsContent, setSectionsContent] = useState({
    section1: "",
    section2: "",
    section3: "",
    section4: "",
    section5: "",
    section6: "",
    section7: "",
    // ... other sections
  });
  const [prevSection, setPrevSection] = useState(null);
  const [prevSectionContent, setPrevSectionContent] = useState(null);
  const [prevSectionByCommand, setPrevSectionByCommand] = useState(null);
  const [prevSectionContentByCommand, setPrevSectionContentByCommand] =
    useState(null);
  const [editableSections, setEditableSections] = useState({
    section1: false,
    section2: false,
    section3: false,
    section4: false,
    section5: false,
    section6: false,
    section7: false,

    // ... other sections
  });

  const sectionRefs = {
    section1: useRef(null),
    section2: useRef(null),
    section3: useRef(null),
    section4: useRef(null),
    section5: useRef(null),
    section6: useRef(null),
    section7: useRef(null),
    // ... other section refs
  };
  const [selectedMedicine, setSelectedMedicine] = useState(null);
  const [selectedTiming, setSelectedTiming] = useState(null);
  const [medicineWithTiming, setMedicineWithTiming] = useState([]);
  const handleAddMedicine = () => {
    setMedicineWithTiming(...medicineWithTiming, {
      medicine: selectedMedicine,
      timing: selectedTiming,
    });
    const updatedMedicineOptions = medicineOptions.map((medicine) => {
      if (medicine.name === selectedMedicine) {
        return { ...medicine, selected: true };
      }
      return medicine;
    });
    setMedicineOptions(updatedMedicineOptions);
    setSelectedMedicine(null);
    setSelectedTiming(null);
  };
  // console.log("Medicine with timing", medicineWithTiming);
  const [medicineOptions, setMedicineOptions] = useState([
    {
      name: "Pneumococcal Vac Polyvalent PNEU25I - 0.5 mL 1 VIAL IM",
      selected: false,
    },
    { name: "Acetaminophen - 500mg", selected: false },
    { name: "Cough syrup - 5mL", selected: false },
    { name: "Paracetamol", selected: false },
    { name: "Painkiller", selected: false },
  ]);
  const timingOptions = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
  ];
  const handleChange = (section, content) => {
    // console.log("Contentttttttttt", content);
    setSectionsContent({
      ...sectionsContent,
      [section]: content,
    });
  };
  const handlePlayButtonClick = (section) => {
    SpeechRecognition.startListening({ continuous: true, language: "en-IN" });
    scrollToSection(section);
    setPrevSection(section);
  };
  const handleVoiceCommand = (command) => {
    switch (command.toLowerCase()) {
      case "go to patient information":
      case "go to patient information section":
      case "go to the patient information":
      case "go to the patient information section":
        scrollToSection("section1");
        setPrevSectionByCommand("section1");
        resetTranscript();
        break;
      case "go to summary of patient":
      case "go to summary of patient section":
      case "go to the summary of patient":
      case "go to the summary of patient section":
        scrollToSection("section2");
        setPrevSectionByCommand("section2");
        resetTranscript();
        break;
      case "go to current complaints":
      case "go to current complaints section":
      case "go to the current complaints":
      case "go to the current complaints section":
        scrollToSection("section3");
        setPrevSectionByCommand("section3");
        resetTranscript();
        break;
      case "go to medications":
      case "go to medications section":
      case "go to the medications":
      case "go to the medications section":
        scrollToSection("section4");
        setPrevSectionByCommand("section4");
        resetTranscript();
        break;
      case "go to lab tests":
      case "go to lab tests section":
      case "go to the lab tests":
      case "go to the lab tests section":
        scrollToSection("section4");
        setPrevSectionByCommand("section4");
        resetTranscript();
        break;
      case "insert line":
        if (prevSectionByCommand) {
          const currentContent = sectionsContent[prevSectionByCommand];
          // Append a line break (<br>) instead of \n
          const updatedContent = currentContent
            ? `${currentContent}<br>`
            : "<br>";
          setPrevSectionContentByCommand(updatedContent);
          setSectionsContent({
            ...sectionsContent,
            [prevSectionByCommand]: updatedContent,
          });
        }
        if (prevSection) {
          const currentContent = modalSectionContent;
          console.log("Current content", currentContent);
          // Append a line break (<br>) instead of \n
          const updatedContent = currentContent
            ? `${currentContent}<br>`
            : "<br>";
          setModalSectionContent(updatedContent);
        }
        resetTranscript();
        break;

      default:
        if (prevSectionByCommand && prevSectionContentByCommand) {
          const currentContent = prevSectionContent;
          const updatedContent = currentContent
            ? `${currentContent} ${command}<br>`
            : `${command}<br>`;
          setSectionsContent({
            ...sectionsContent,
            [prevSectionByCommand]: updatedContent,
          });
        }
        if (prevSection && modalSectionContent) {
          const currentContent = modalSectionContent;
          const updatedContent = currentContent
            ? `${currentContent} ${command}`
            : `${command}`;
          setModalSectionContent(updatedContent);
        }
        break;
    }
  };

  const handleReplace = (command) => {
    const replacePattern = /replace (.*) with (.*)/i;
    const match = command.match(replacePattern);

    if (match && match.length === 3) {
      const wordToReplace = match[1];
      const replacementWord = match[2];
      // console.log("Word to Replace ", wordToReplace);
      // console.log("Replacement Word", replacementWord);

      let updatedContent = sectionsContent[prevSection] || "";

      if (prevSection && sectionsContent[prevSection]) {
        // Replace the word with the specified replacement word
        updatedContent = updatedContent.replace(
          new RegExp(`\\b${wordToReplace}\\b`, "gi"),
          replacementWord
        );
      }
      setPrevSectionContent(updatedContent);
      setSectionsContent({
        ...sectionsContent,
        [prevSection]: updatedContent,
      });
    }

    resetTranscript();
  };

  const scrollToSection = (section) => {
    if (sectionRefs[section] && sectionRefs[section].current) {
      sectionRefs[section].current.scrollIntoView({ behavior: "smooth" });
      const updatedEditableSections = {};
      Object.keys(editableSections).forEach((key) => {
        updatedEditableSections[key] = key === section;
      });

      setEditableSections(updatedEditableSections);
    }
  };

  const handleVoiceRecognition = () => {
    if (transcript) {
      if (transcript.toLowerCase().trim().endsWith("insert line")) {
        handleVoiceCommand("insert line");
      } else if (transcript.toLowerCase().includes("replace")) {
        handleReplace(transcript);
      } else {
        handleVoiceCommand(transcript);
      }

      // resetTranscript();
    }
  };

  useEffect(() => {
    setTimeout(() => {
      handleVoiceRecognition();
    }, 3000);
    // handleVoiceRecognition();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transcript]);
  // console.log("Transcriptttttttttttttttttttttttttttt", transcript.length);
  const startListening = () =>
    SpeechRecognition.startListening({ continuous: true, language: "en-IN" });

  const config = useMemo(
    () => ({
      buttons: "",

      showXPathInStatusbar: false,
      showCharsCounter: false,
      showWordsCounter: false,
      toolbarAdaptive: false,

      enableDragAndDropFileToEditor: true,
    }),
    []
  );
  const [modalOpen, setModalOpen] = useState(false);
  const [modalSection, setModalSection] = useState(null);
  const [modalSectionName, setModalSectionName] = useState(null);
  const [modalSectionContent, setModalSectionContent] = useState(null);
  const [listening, setListening] = useState(false);
  const openModal = (section, sectionName) => {
    setListening(true);
    // console.log("Clickled");
    setModalSection(section);
    setModalSectionName(sectionName);
    console.log("Section contenttttt", sectionsContent[section]);
    setModalSectionContent(sectionsContent[section]);
    setModalOpen(true);
    // SpeechRecognition.startListening({ continuous: true, language: "en-IN" });
    setPrevSection(section);
    setPrevSectionContent(sectionsContent[section]);
  };
  console.log("Modal Contenttttttttttttt", modalSectionContent);

  const handleModalSectionContent = (content) => {
    setModalSectionContent(content);
  };
  const saveModalContent = () => {
    const currentContent = modalSectionContent;
    const updatedContent = currentContent
      ? `${currentContent}`
      : `${currentContent}`;
    setSectionsContent({
      ...sectionsContent,
      [prevSection]: updatedContent,
    });
    setModalOpen(false);
    setModalSection(null);
    setModalSectionName(null);
    setModalSectionContent(null);
    SpeechRecognition.stopListening();
  };
  const openNewPrescription = () => {
    setNewPresButtonClicked(true);
  };
  useEffect(() => {
    let updatedTranscript = "";
    // console.log("Transcript", transcript);
    if (transcript.length !== 0) {
      updatedTranscript = transcript.replace(
        new RegExp("go to the next line", "g"),
        "\n" // Use "\n" to represent a newline character
      );
    }
    // if (editing) {
    //   updatedTranscript = message + updatedTranscript;
    //   setEditing(false);
    // }

    // console.log("Transcript", transcript);
    // console.log("Updated Transcript", updatedTranscript);
    setMessage(prevMessage + updatedTranscript);
  }, [transcript]);
  const handleTextChange = (e) => {
    resetTranscript();
    setEditing(true);
    setPrevMessage(e.target.value);
    setMessage(e.target.value);
    // console.log("Event Target", e.target);
  };
  const handleTextChange2 = (e) => {
    e.preventDefault();
    resetTranscript();
    setEditing(true);
    // console.log(
    //   "Div contentttttttttttttttttttttt",
    //   e.currentTarget.textContent
    // );
    // console.log("Div contentttttttttttttttttttttt", e.target.innerText);
    // console.log("Event targettttttt", e.target);
    const boldSections = [
      "Section 1",
      "Section 2",
      "Section 3",
      "Section 4",
      "Section 5",
      "Section 6",
      "Section 7",
    ];

    // Split the text into lines
    const lines = e.target.innerText.split("\n");

    // console.log("Linesssssssss", lines);

    // Iterate through lines and apply bold formatting to sections
    const formattedText = lines
      .map((line) => {
        const section = boldSections.find((s) => line.includes(s));
        return section ? `<b>${line}</b>` : line;
      })
      .join("\n");
    // console.log("Formatted Text", formattedText);

    setPrevMessage(formattedText);
    setMessage(formattedText);
    // console.log("Event Target", e.target);
  };
  // const handleTextChange3 = (e) => {
  //   // e.preventDefault();
  //   // resetTranscript();
  //   // setEditing(true);
  //   console.log(
  //     "Div contentttttttttttttttttttttt",
  //     e.currentTarget.textContent
  //   );
  //   console.log("Div contentttttttttttttttttttttt", e.target.value);
  //   // setPrevMessage(e.currentTarget.textContent);
  //   setMessage2(e.currentTarget.textContent);
  //   // console.log("Event Target", e.target);
  // };
  const resetTextArea = () => {
    resetTranscript();
    setPrevMessage("");
    setMessage("");
  };
  const [summaryData, setSummaryData] = useState(null);
  const [newPresButtonClicked, setNewPresButtonClicked] = useState(false);
  const [summaryToDisplay, setSummaryToDisplay] = useState(null);
  const [prescriptionsForTimeline, setPrescriptionsForTimeline] = useState([]);
  const [diagsForTimeline, setDiagsForTimeline] = useState([]);
  const [presTrue, setPresTrue] = useState(false);
  const [diagTrue, setDiagTrue] = useState(false);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  const handleDownload = async () => {
    const input = document.getElementById("prescription-template");
    html2canvas(input, { useCORS: true, allowTaint: true, scrollY: 0 }).then(
      (canvas) => {
        const image = { type: "jpeg", quality: 0.98 };
        const margin = [0.5, 0.5];

        var imgWidth = 8.5;
        var pageHeight = 11;

        var innerPageWidth = imgWidth - margin[0] * 2;
        var innerPageHeight = pageHeight - margin[1] * 2;

        // Calculate the number of pages.
        var pxFullHeight = canvas.height;
        var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
        var nPages = Math.ceil(pxFullHeight / pxPageHeight);
        // console.log("Numbet of pages", nPages);
        // console.log("Full heignt", pxFullHeight);
        // console.log("Page Full height", pxPageHeight);
        // console.log("Canvas width and height", canvas.width, canvas.height);

        // Define pageHeight separately so it can be trimmed on the final page.
        var pageHeight = innerPageHeight;

        // Create a one-page canvas to split up the full image.
        var pageCanvas = document.createElement("canvas");
        var pageCtx = pageCanvas.getContext("2d");
        pageCanvas.width = canvas.width;
        pageCanvas.height = pxPageHeight;

        // Initialize the PDF.
        var pdf = new jsPDF("p", "in", [8.5, 11]);

        for (var page = 0; page < nPages; page++) {
          // Trim the final page to reduce file size.
          if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
            pageCanvas.height = pxFullHeight % pxPageHeight;
            pageHeight =
              (pageCanvas.height * innerPageWidth) / pageCanvas.width;
          }

          // Display the page.
          var w = pageCanvas.width;
          var h = pageCanvas.height;
          pageCtx.fillStyle = "white";
          pageCtx.fillRect(0, 0, w, h);
          pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

          // Add the page to the PDF.
          if (page > 0) pdf.addPage();
          debugger;
          var imgData = pageCanvas.toDataURL(
            "image/" + image.type,
            image.quality
          );
          pdf.addImage(
            imgData,
            image.type,
            margin[1],
            margin[0],
            innerPageWidth,
            pageHeight
          );
        }

        pdf.save(`Prescription.pdf`);
      }
    );
  };
  useEffect(() => {
    onSubmit();
  }, [summaryData]);

  useEffect(() => {
    if (newPresButtonClicked && summaryToDisplay !== null) {
      // console.log("Inside Ifffffffffffffffffffffffffffffff");
      // console.log(newPresButtonClicked);
      // Define an array of section names to be bolded
      const boldSections = [
        "Section 1",
        "Section 2",
        "Section 3",
        "Section 4",
        "Section 5",
        "Section 6",
        "Section 7",
      ];

      // Split the text into lines
      const lines = summaryToDisplay.split("\n");

      // console.log("Linesssssssss", lines);

      // Iterate through lines and apply bold formatting to sections
      const formattedText = lines
        .map((line) => {
          const section = boldSections.find((s) => line.includes(s));
          return section ? `<b>${line}</b>` : line;
        })
        .join("\n");
      // console.log("Formatted Text", formattedText);
      setMessage(formattedText);
      setPrevMessage(formattedText);

      const sections = summaryToDisplay.split("\n\n");
      const ans = {
        section1: "",
        section2: "",
        section3: "",
        section4: "",
        section5: "",
        section6: "",
        section7: "",
      };
      // console.log("Sectionssssssssssssssssss", sections);
      sections.map((section, index) => {
        const sectionContent = section.replace(/Section \d+ - /, "");

        // Split into title and value
        const [title, ...valueArray] = sectionContent.split(":");

        // Join the remaining array elements to form the value
        const value = valueArray.join(":").trim().replace(/\n/g, "<br>"); // Replace \n with <br>

        // Update the ans object based on the index
        ans[`section${index + 1}`] = value;
      });
      setSectionsContent(ans);
    }
  }, [summaryToDisplay, newPresButtonClicked]);
  // // Function to generate a PDF from fhirArrays
  const generatePDF = (summary) => {
    return new Promise((resolve, reject) => {
      try {
        // Create a document definition
        // console.log("Summary from generate pdf", summary);
        const docDefinition = {
          content: [{ text: JSON.stringify(summary, null, 200) }],
        };

        if (summary !== null && summary !== undefined) {
          // Generate the PDF
          pdfMake.createPdf(docDefinition).getBlob((blob) => {
            const downloadLink = document.createElement("a");
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.download = "generated.pdf";

            // Trigger the download
            downloadLink.style.display = "none";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);

            resolve(blob);
          });
        }
      } catch (error) {
        reject(error);
      }
    });
  };

  const onSubmit = () => {
    // console.log("onSubmit");

    //Generate the PDF file
    if (Token()) {
      generatePDF(summaryData)
        .then((blob) => {
          const pdfFile = new File([blob], "generated.pdf", {
            type: "application/pdf",
          });

          // console.log("File", pdfFile);
          // console.log("File", pdfFile);

          // The rest of your code for uploading the PDF
          if (pdfFile) {
            const bodyFormData = new FormData();
            bodyFormData.append(
              "HIP_ID",
              sessionStorage.getItem("facility_name")
            );
            bodyFormData.append("documentType", "pdf");
            bodyFormData.append("file", pdfFile);

            axios
              .post(
                `${REACT_APP_BACKEND_ROUTE_URL}add_pdf_via_upload/`,
                bodyFormData,
                {
                  headers: headers,
                }
              )
              .then((response) => {
                // console.log("Response", response);
                // setSourceId(response.data.source_id);
                // console.log("Source iddddd", response.data.source_id);
                var postdata = {};

                postdata.sourceId = response.data.source_id;
                postdata.messages = [];
                var message = {
                  role: "user",
                  content:
                    "Treat me as a doctor and I wanted to write a prescription maintaining formatted  clinical documents standard for a patient whose details like name , gender and birthdate is provided and  who is complaining which is mentioned in complaints,please advise medicines and lab tests with advice and suggestions on permitted foods, safety factors and precautionary measures. You can also mention an emergency medicine for worst kind of situations, follow-up timeline for the patient to come back. Also you can mention an emergency number the patient can call in case there is a need for them to contact. Please write a summary of the patient, as he is a frequent visitor, he has a COPD problem which began for a year's time, last year, please mention the reference and draw some inference from that particular element. So this is going to be a prescription, and it has to be detailed and also it should follow the regulatory guidelines from FDA.Give me response section wise.Section 1-Patient Information,Section 2-Summary of the patient,Section 3-Current Complaints,Section 4-Medications,Section 5-Lab Tests,Section 6-Advice and Suggestions,Section 7-Prescription",
                };
                postdata.messages.push(message);
                axios
                  .post(
                    `${REACT_APP_BACKEND_ROUTE_URL}chat_with_pdf/`,
                    postdata,
                    {
                      headers: headers,
                    }
                  )
                  .then((response) => {
                    // console.log("Response for summary", response);

                    // setSourceId(response.source_id)

                    setSummaryToDisplay(response.data.answer);
                    const dataObject = JSON.parse(response.config.data);

                    // Access the sourceId property
                    const sourceId = dataObject.sourceId;

                    // console.log(sourceId); // This will print the sourceId
                    // setIsSumamryGenerated(true);
                    // var postdata = {};
                    // console.log("sourceId issssssssssss", sourceId);
                    // postdata.sourceId = sourceId;
                    // postdata.messages = [];
                    // var message = {
                    //   role: "user",
                    //   content:
                    //     "I give you a pdf .Now as a medical practitioner you are suppossed to return me top three questions to be asked to patient based on the passed data",
                    // };
                    // postdata.messages.push(message);
                    // axios
                    //   .post(
                    //     `${REACT_APP_BACKEND_ROUTE_URL}chat_with_pdf/`,
                    //     postdata,
                    //     {
                    //       headers: headers,
                    //     }
                    //   )
                    //   .then((response) => {
                    //     console.log("Response for questions", response);
                    //     // setSourceId(response.source_id);

                    //     setTop3Questions(response.data.answer);
                    //     setIsSumamryGenerated(true);
                    //   })
                    //   .catch((err) => {
                    //     console.log(err);

                    //   });
                  })
                  .catch((err) => {
                    console.log(err);
                    toast.error(err);
                  });

                // //ChangeCursor();
              })
              .catch((err) => {
                console.error(err);
                toast.error(err);
                console.log("error");
                // Handle error as needed
              });
          }
        })
        .catch((err) => {
          console.error(err);
          toast.error(err);
          console.log("error");
          // Handle error as needed
        });
    }
  };
  const location = useLocation();
  const state = props.stateProps;
  const prescriptionData = props.prescriptionData;
  console.log("Prescription Page state", state);
  console.log("Prescription Page prescriptionData", prescriptionData);
  const [fhirArrays, setFhirArrays] = useState([]);
  const [prescriptionsArray, setPrescriptionsArray] = useState([]);
  // console.log(location?.state?.fhirArrData);
  const [numPages, setNumPages] = useState(null);
  const [modalPageNumber, setModalPageNumber] = useState(1);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [fileType, setFileType] = useState(null);
  var [doctorRecommendations, setDoctorRecommendations] = useState("");
  useEffect(() => {
    var fhirData = state?.fhirArrData;
    console.log("Data Found in useEffect", fhirData);
    if (fhirData) {
      console.log("In if block");
      setFhirArrays(fhirData);
    }
  }, []);
  console.log(fhirArrays);

  console.log("Prescription array ", prescriptionsArray);

  // var uuidArrs = []
  // var uuidArr = []
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function handleRecommendationsChange(value) {
    setDoctorRecommendations(value);
    // console.log(doctorRecommendations)
  }

  var prescriptionList = props.prescriptionList;
  var finalStatus = props.finalStatus;
  var patientData = props.patientData;
  var type = props.type;

  function addCareContexts() {
    // Adding the doctorRecommendations to Care Contexts

    axios
      .post(`${REACT_APP_BACKEND_ROUTE_URL}auth_init_workflow/`, {
        query: {
          id: patientData.abha_id ? patientData.abha_id : patientData.abha_no,
          purpose: "LINK",
          authMode: "DEMOGRAPHICS",
          requester: {
            type: "HIP",
            id: "HLTHTEK_HIP_1",
          },
        },
      })
      .then((response) => {
        console.log("GOT THIS AUTH INIT RESPONSE");

        console.log(response.data);

        var txn_id = response.data.transaction_id;

        axios
          .post(`${REACT_APP_BACKEND_ROUTE_URL}auth_confirm_workflow/`, {
            transactionId: txn_id,
            credential: {
              demographic: {
                name: patientData.name,
                gender: patientData.gender[0],
                dateOfBirth: patientData.dob,
                identifier: {
                  type: "MOBILE",
                  value: patientData.phone_no,
                },
              },
            },
          })
          .then((response) => {
            console.log("GOT AUTH CONFIRM RESPONSE");
            console.log(response.data);
            var linking_token = response.data.access_token;

            axios
              .post(`${REACT_APP_BACKEND_ROUTE_URL}add_context_workflow/`, {
                access_token: linking_token,
                patient_info: {
                  referenceNumber: patientData.patient_id, // This should the the patient ID otherwise will cause issues while data transfer
                  display: patientData.name,
                  careContexts: [
                    {
                      referenceNumber: "Care Context by Dr Saurabh Tripathi",
                      display: doctorRecommendations,
                    },
                  ],
                },
              })
              .then((response) => {
                console.log("GOT ADD CONTEXT RESPONSE");

                console.log(response.data);
              })
              .catch((error) => {
                console.log("ADD CONTEXT FAILED");
                console.log(error);
              });
          })
          .catch((error) => {
            console.log("AUTH CONFIRM FAILED");
            console.log(error);
          });
      })
      .catch((error) => {
        console.log("AUTH INIT FAILED");
        console.log(error);
      });
  }

  // console.log("PRESCRIPTION LIST ",prescriptionList)
  // console.log("finalStatus LIST ",finalStatus)
  // console.log("Printing props ",props)

  var docOrImg = [];

  if (prescriptionList !== undefined && prescriptionList.length > 0) {
    for (var i = 0; i < prescriptionList.length; i++) {
      var binary_pdf = "";
      for (
        var j = 0;
        j < prescriptionList[i].decrypted_json.entry.length;
        j++
      ) {
        if (
          prescriptionList[i].decrypted_json.entry[j].fullUrl.startsWith(
            "Binary"
          ) &&
          prescriptionList[i].decrypted_json.entry[j].resource.contentType ==
            "application/pdf"
        ) {
          binary_pdf =
            prescriptionList[i].decrypted_json.entry[j].resource.data;
          var newdocOrImg = docOrImg;
          var index = newdocOrImg.length;
          newdocOrImg[index] = {};
          newdocOrImg[index].file = `data:application/pdf;base64,${binary_pdf}`;
          newdocOrImg[index].type = "pdf";
          newdocOrImg[index].name =
            (type == "Prescription" ? "Prescription" : "Lab Report ") +
            (index + 1).toString();
          newdocOrImg[index].doctor = prescriptionList[i].doctor;
          newdocOrImg[index].clinic = prescriptionList[i].clinic;
          newdocOrImg[index].date_time = prescriptionList[i].date_time;
          docOrImg = newdocOrImg;
        }
      }
    }
  }

  const formatDate = (visitDatetime) => {
    const formattedDate = new Date(visitDatetime);

    const day = String(formattedDate.getDate()).padStart(2, "0");
    const month = String(formattedDate.getMonth() + 1).padStart(2, "0"); // January is 0!
    const year = String(formattedDate.getFullYear()).slice(-2); // Extract the last two digits of the year

    let hours = formattedDate.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight
    const minutes = String(formattedDate.getMinutes()).padStart(2, "0");

    const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;

    console.log(formattedDateTime);
    return formattedDateTime;
  };

  const viewAttachmentBinary = (attachment) => {
    // console.log(attachment);

    // Wrap the content in a div with overflow for scrollability
    let modalContent;
    if (attachment.content_type === "application/pdf") {
      const url = `data:application/pdf;base64,${attachment.content_data}#toolbar=0`;
      modalContent = (
        <iframe
          width="100%"
          height="100%"
          src={url}
          title="Prescription"
        ></iframe>
      );
    } else if (
      attachment.content_type === "image/jpeg" ||
      attachment.content_type === "image/jpg" ||
      attachment.content_type === "image/png"
    ) {
      const url = `data:${attachment.content_type};base64,${attachment.content_data}`;
      // Display image files
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "80%",
            maxHeight: "700px",
          }}
        >
          <img src={url} alt="Attachment" />
        </div>
      );
    } else {
      // Default to displaying it as an image if content type is unknown
      const url = `data:${attachment.content_type};base64,${attachment.content_data}`;
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "100%",
          }}
        >
          <img src={url} alt="Attachment" />
        </div>
      );
    }

    setModalContent(modalContent);
    setShowModal(true);
  };

  const viewAttachmentDocumentReference = (attach) => {
    // console.log(attachment);
    let attachment = attach.content[0];
    // Wrap the content in a div with overflow for scrollability
    let modalContent;
    if (attachment.content_type === "application/pdf") {
      const url = `data:application/pdf;base64,${attachment.data}#toolbar=0`;
      modalContent = (
        <iframe width="100%" height="100%" src={url} title={attach.id}></iframe>
      );
    } else if (
      attachment.content_type === "image/jpeg" ||
      attachment.content_type === "image/jpg" ||
      attachment.content_type === "image/png"
    ) {
      const url = `data:${attachment.content_type};base64,${attachment.data}`;
      // Display image files
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "80%",
            maxHeight: "700px",
          }}
        >
          <img src={url} alt={attach.id} title={attach.id} />
        </div>
      );
    } else {
      // Default to displaying it as an image if content type is unknown
      const url = `data:${attachment.content_type};base64,${attachment.data}`;
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "100%",
          }}
        >
          <img src={url} alt="Attachment" />
        </div>
      );
    }

    setModalContent(modalContent);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalContent(null);
  };

  const renderedSections = (message) => {
    console.log("Message", message);
    const sections = message.split("\n\n");
    console.log("Sectionssssssssssssssssss", sections);
    const ans = sections.map((section, index) => {
      const sectionContent = section.replace(/Section \d+ - /, "");

      // Split into title and value
      const [title, ...valueArray] = sectionContent.split(":");

      // Join the remaining array elements to form the value
      const value = valueArray.join(":").trim();
      console.log("Title", title);
      console.log("Value", value);
      return (
        <Grid key={index} padding={2}>
          <Typography variant="h4" color="grey">
            {title}
          </Typography>
          <textarea
            className="new-prescription-card"
            style={{
              marginTop: "20px",
              marginBottom: "10px",
              width: "100%",
              height: "150px",
              whiteSpace: "pre-wrap",
            }}
            value={value}
            readOnly
          />
        </Grid>
      );
    });
    return ans;
  };

  // console.log("Message valueeeeeeee", message);
  return (
    <>
      <DoctorconsoleGrid>
        {modalIsOpen ? (
          <div className="modal">
            <div className="modal-content">
              <button
                onClick={() => {
                  setModalIsOpen(false);
                  setModalPageNumber(1);
                }}
              >
                <img src={closeIcon} alt="modal close" />
              </button>
              <div className="pdf-file">
                {fileType === "pdf" ? (
                  <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
                    <Page pageNumber={modalPageNumber} />
                  </Document>
                ) : (
                  <img src={file} alt="Test Report" className="report-photo" />
                )}
              </div>
              {fileType === "pdf" && (
                <div className="page-controls">
                  <button
                    type="button"
                    onClick={() => setModalPageNumber(modalPageNumber - 1)}
                    disabled={modalPageNumber === 1}
                  >
                    ‹
                  </button>
                  <span>
                    {modalPageNumber} of {numPages}
                  </span>
                  <button
                    type="button"
                    onClick={() => setModalPageNumber(modalPageNumber + 1)}
                    disabled={modalPageNumber === numPages}
                  >
                    ›
                  </button>
                </div>
              )}
              <button
                onClick={() => {
                  setModalIsOpen(false);
                  setModalPageNumber(1);
                }}
              >
                <img src={closeIcon} alt="modal close" />
              </button>
            </div>
          </div>
        ) : null}

        <div className="accordion-container"></div>
        <div>
          {prescriptionData !== undefined && prescriptionData !== null ? (
            <>
              <HiTypeHeader
                date={prescriptionData.Date}
                name={"Prescription Record"}
                encounter={prescriptionData.Encounter}
                organizationDetails={prescriptionData.Organization}
                practitionerDetails={prescriptionData.Practitioner}
              />
              {Object.keys(prescriptionData).map(
                (categoryKey) =>
                  ![
                    "Encounter",
                    "Date",
                    "Organization",
                    "Practitioner",
                    "Patient",
                  ].some(
                    (substring) =>
                      substring === categoryKey.match(/\(([^)]+)\)/)?.[1] ||
                      substring == categoryKey // Extract and check in the same line
                  ) && (
                    <Accordion className="innermost-accordion" defaultExpanded>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        className="innermost-accordion-summary"
                      >
                        <Typography
                          sx={{ color: "white" }}
                          className="accordion-section-title"
                        >
                          {categoryKey}
                        </Typography>
                      </AccordionSummary>

                      <AccordionDetails>
                        <Row
                          style={{
                            marginTop: "30px",
                          }}
                        >
                          <Col
                            area="span 12"
                            style={{ border: "2px solid #ebf5f4" }}
                          >
                            {categoryKey.includes("Binary") ||
                            categoryKey.includes("DocumentReference") ? (
                              <div
                                style={{
                                  marginTop: "20px",
                                  fontWeight: "bold",
                                  marginBottom: "50px",
                                  fontSize: "16px",
                                }}
                              >
                                Attachments :{" "}
                                {prescriptionData[categoryKey].length > 0
                                  ? prescriptionData[categoryKey].map(
                                      (attachment) => (
                                        <button
                                          style={{
                                            marginRight: "10px",
                                            backgroundColor: "#007bff",
                                            color: "#fff",
                                            border: "none",
                                            padding: "5px 10px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            categoryKey.includes("Binary")
                                              ? viewAttachmentBinary(attachment)
                                              : viewAttachmentDocumentReference(
                                                  attachment
                                                )
                                          }
                                          title={attachment.id}
                                        >
                                          {" "}
                                          {/* Click here to see{" "} */}
                                          <i className="fas fa-file"></i>
                                        </button>
                                      )
                                    )
                                  : "No attachments found!"}
                              </div>
                            ) : (
                              <Table responsive size="lg">
                                <TableHead
                                  style={{
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                    gridTemplateColumns:
                                      "250px 250px 250px 120px 120px",
                                    justifyContent: "center",
                                  }}
                                >
                                  {/* Define table headers based on category */}
                                  {categoryKey.includes("MedicationRequest") ? (
                                    <>
                                      <td>Medication</td>
                                      <td>Dosage and Route</td>
                                      <td>Reasons</td>
                                      <td>Authored On</td>

                                      {/* <td>Authored On</td> */}
                                      {/* Add other headers specific to Medications */}
                                    </>
                                  ) : categoryKey.includes("Observation") ? (
                                    <>
                                      <td>Title</td>

                                      <td>Value</td>
                                      <td>Unit</td>
                                      <td>Notes</td>
                                      <td>Status</td>
                                    </>
                                  ) : null}
                                </TableHead>
                                <tbody>
                                  {/* Render rows for each item within the category */}
                                  {prescriptionData?.[categoryKey].map(
                                    (item) => (
                                      <tr key={item.id}>
                                        {" "}
                                        {/* Render cells based on category */}
                                        {categoryKey.includes(
                                          "MedicationRequest"
                                        ) ? (
                                          <>
                                            {console.log(
                                              "Medication Item Found",
                                              categoryKey,
                                              item
                                            )}
                                            <td>
                                              {item?.medication
                                                ? typeof item.medication ===
                                                  "object"
                                                  ? item.medication.display
                                                  : item.medication
                                                : typeof item?.code?.[0] ===
                                                    "object" &&
                                                  item.code[0]?.display
                                                ? item.code[0].display
                                                : item.code[0]}
                                            </td>

                                            <td>
                                              {item?.dosage?.[0]}
                                              {item?.dosage?.[1]?.display
                                                ? ` ${item.dosage[1].display}`
                                                : ""}
                                            </td>
                                            <td>
                                              {item?.reason_code?.length > 0
                                                ? item.reason_code.join(", ")
                                                : "-"}
                                            </td>
                                            <td>
                                              {item.authored_on
                                                ? formatDateIST(
                                                    item.authored_on
                                                  )
                                                : "-"}
                                            </td>

                                            {/* <td>{formatDate(item?.date)}</td> */}
                                            {/* Render other cells specific to Medications */}
                                          </>
                                        ) : categoryKey.includes(
                                            "Observation"
                                          ) ? (
                                          <>
                                            {console.log(
                                              "Item Found",
                                              categoryKey
                                            )}
                                            <td>
                                              {item?.code &&
                                              item.code.length > 0
                                                ? item.code[
                                                    item.code.length - 1
                                                  ].text ||
                                                  item.code[
                                                    item.code.length - 1
                                                  ].display ||
                                                  "-"
                                                : "-"}
                                            </td>

                                            <td>
                                              {item &&
                                              item.value_quantity &&
                                              Object.keys(item.value_quantity)
                                                .length > 0
                                                ? item.value_quantity.value !==
                                                  undefined
                                                  ? item.value_quantity.value
                                                  : item.value_quantity
                                                      .string ||
                                                    item.value_quantity
                                                      .value_text ||
                                                    item.value_quantity
                                                      .value_datetime
                                                : "-"}
                                            </td>

                                            <td>
                                              {item?.value_quantity?.unit?.trim() ||
                                                "-"}
                                            </td>

                                            <td>
                                              {item?.note &&
                                              item?.note.length > 0
                                                ? item?.note?.[0].text
                                                : "-"}
                                            </td>
                                            <td>{item && item.status}</td>

                                            {/* <td>{formatDate(item?.date)}</td> */}
                                            {/* Render other cells specific to Medications */}
                                          </>
                                        ) : null}
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </Table>
                            )}
                          </Col>
                        </Row>
                      </AccordionDetails>
                    </Accordion>
                  )
              )}
            </>
          ) : (
            <>
              {" "}
              <div
                style={{
                  marginTop: "20px",
                  padding: "10px",
                  backgroundColor: "#3AC8BA",
                  fontWeight: "bold",
                  fontSize: "25px",
                  color: "black",
                }}
              >
                No previous Prescription found!
              </div>
            </>
          )}
          <Modal open={showModal} onClose={closeModal}>
            <Box className="modal-box">
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <IconButton onClick={closeModal}>
                  <CloseIcon />
                </IconButton>
              </div>
              {/* <Typography variant="h6">PDF Viewer</Typography> */}

              <div style={{ flex: 1 }}>{modalContent}</div>
            </Box>
          </Modal>
          {/* <p class="screen3-card-title">Recommendations</p>
          <textarea
            name="recommendations"
            id="recommendations"
            cols="30"
            rows="10"
            class="screen3-recommendations"
            value={doctorRecommendations}
            onChange={(event) => {
              handleRecommendationsChange(event.target.value);
            }}
          ></textarea>
          <div class="screen3-recommendation-buttons">
            <button
              class="screen3-recommendation-cancel-button"
              style={{
                padding: "5px",
                border: "1px solid black",
                backgroundColor: "white",
              }}
            >
              Cancel
            </button>
            &nbsp;
            <button
              class="screen3-recommendation-save-button"
              style={{
                padding: "5px",
                border: "1px solid black",
                backgroundColor: "white",
              }}
              onClick={addCareContexts}
            >
              Save
            </button>
          </div> */}
        </div>
      </DoctorconsoleGrid>
      <Helmet>
        <link
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
          rel="stylesheet"
          integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
          crossorigin="anonymous"
        />
      </Helmet>
    </>
  );
}
const datapoints = [20, 50, 30, 20, 35, 40, 30, 20, 40, 30];
const state = {
  labels: [
    "Jan-2021",
    "Feb-2021",
    "Mar-2021",
    "Apr-2021",
    "May-2021",
    "Jun-2021",
    "Jul-2021",
    "Aug-2021",
    "Sep-2021",
  ],
  datasets: [
    {
      //label: 'Cubic interpolation (monotone)',
      label: "WBC Count",
      data: datapoints,
      //borderColor: 'rgba(255, 0, 0)',
      borderColor: "rgba(51, 0, 0, 0.8)",
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      borderWidth: 1.5,
      fill: false,
      //cubicInterpolationMode: 'monotone',
      tension: 0,
    },
    /*, {
        label: 'Cubic interpolation',
        data: datapoints,
        borderColor: 'rgba(0, 0, 255)',
        borderWidth: 1.5,
        fill: false,
        tension: 0.4
    }, {
        label: 'Linear interpolation (default)',
        data: datapoints,
        borderColor: 'rgba(0, 128 ,0)',
        borderWidth: 1.5,
        fill: false
    }*/
  ],
};

const progressColors = {
  green: "#01A601",
  pink: "#E87971",
  blue: "#05C4E2",
  orange: "#F66220",
};

const Progress = styled.div`
  height: 0.6rem;
  background-color: #ccd0d2;
  display: grid;
  grid-template-columns: ${(props) => props.width} calc(
      100% - ${(props) => props.width}
    );
  border-radius: 50px;
  width: 100%;
  .progress-item {
    height: 0.6rem;
    background-color: ${({ color }) => progressColors[color]};
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-radius: 50px;
    span {
      font-size: 0.8rem;
      color: #94999c;
      margin-top: -3rem;
    }
  }
  .bg {
    width: 100%;
  }
`;
const ProgressBar = ({ color, width }) => {
  return (
    <Progress color={color} width={width}>
      <div className="progress-item">
        <span>{width}</span>
      </div>
      <div className="bg"></div>
    </Progress>
  );
};

export default PrescriptionCard;
